var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"property-editor-div"},[_c('quotation-editor',{model:{value:(_vm.editingSource),callback:function ($$v) {_vm.editingSource=$$v},expression:"editingSource"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }